export const WEBVIEW_BOOT_HEALTHY_EVENT = 'infor-app-boot-healthy';

export const WEBVIEW_BOOT_HEALTHY_FLAG = '__INFOR_APP_BOOT_HEALTHY__';

export const WEBVIEW_BOOT_WATCHDOG_TIMEOUT_MS = 25_000;

export const ANDROID_SYSTEM_WEBVIEW_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.google.android.webview';

declare global {
  interface Window {
    __INFOR_APP_BOOT_HEALTHY__?: boolean;
    InforBootGuard?: {
      markBootHealthy?: () => void;
    };
  }
}

const notifyNativeBootHealthy = (): void => {
  try {
    window.InforBootGuard?.markBootHealthy?.();
  } catch {
    /* bridge nativa indisponível */
  }
};

export const markWebviewBootHealthy = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.__INFOR_APP_BOOT_HEALTHY__ = true;
  window.dispatchEvent(new Event(WEBVIEW_BOOT_HEALTHY_EVENT));

  notifyNativeBootHealthy();

  let attempts = 0;
  const intervalId = window.setInterval(() => {
    attempts += 1;
    notifyNativeBootHealthy();

    if (attempts >= 20) {
      window.clearInterval(intervalId);
    }
  }, 250);
};

export const isWebviewBootHealthy = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.__INFOR_APP_BOOT_HEALTHY__ === true;
};
